var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1123 10.8537V12.7782C14.113 12.9568 14.0764 13.1336 14.0049 13.2973C13.9333 13.461 13.8283 13.608 13.6967 13.7287C13.565 13.8495 13.4096 13.9414 13.2404 13.9987C13.0711 14.0559 12.8918 14.0772 12.7139 14.0611C10.74 13.8466 8.84391 13.1721 7.17801 12.0918C5.62811 11.1069 4.31406 9.79287 3.32919 8.24297C2.2451 6.5695 1.57044 4.6642 1.35988 2.68142C1.34385 2.50404 1.36493 2.32526 1.42178 2.15646C1.47863 1.98767 1.57001 1.83256 1.69009 1.70102C1.81017 1.56947 1.95632 1.46437 2.11925 1.39241C2.28217 1.32044 2.4583 1.28319 2.63641 1.28302H4.56082C4.87212 1.27996 5.17393 1.3902 5.40997 1.59319C5.64601 1.79619 5.80018 2.07809 5.84375 2.38635C5.92498 3.0022 6.07561 3.60689 6.29278 4.18888C6.37909 4.41848 6.39777 4.668 6.34661 4.90789C6.29545 5.14778 6.17659 5.36797 6.00412 5.54238L5.18946 6.35705C6.10262 7.96299 7.43232 9.2927 9.03827 10.2059L9.85294 9.3912C10.0273 9.21873 10.2475 9.09987 10.4874 9.04871C10.7273 8.99755 10.9768 9.01623 11.2064 9.10253C11.7884 9.3197 12.3931 9.47034 13.009 9.55156C13.3206 9.59552 13.6052 9.75248 13.8086 9.99257C14.012 10.2327 14.1201 10.5392 14.1123 10.8537Z",
    stroke: "white",
    strokeWidth: 1.28294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneW);
export default __webpack_public_path__ + "static/media/phone-w.36dbbe935bfb407d6de8bbb10eb9b5f3.svg";
export { ForwardRef as ReactComponent };